import React from 'react';
import {useField} from 'formik';
import Wrapper from '../../../../../../wrapper/wrapper.jsx';
import Tooltip from '../../../../../../tooltip/tooltip.jsx';
import Link from 'components/link/link.jsx';
import Text from '../../../../../../text/text.jsx';
import {Toggle} from 'components/form/form.jsx';

const IsLeadscanner = () => {
  const [field, , helpers] = useField('is_leadscanner');

  return (
    <Wrapper alignItems="center">
      <Toggle
        label={`Создавать лиды от LeadScanner`}
        isChecked={!!field.value}
        onChange={value => helpers.setValue(value ? 1 : 0)}
      />

      <Tooltip style={{margin: '-8px 0'}}>
        <Text>
          <Link
            href="https://whatcrm.gitbook.io/whatcrm-docs/produkty/telegram/nastroika-servisa-leadscanner"
            target="_blank"
          >
            {`Настройка сервиса LeadScanner`}
          </Link>
        </Text>
      </Tooltip>
    </Wrapper>
  );
};

export default IsLeadscanner;
